import { setAuto } from './setAuto';

export const Search = {
	setAuto
};
